import React, { FC }                                    from 'react';
import { ENVIRONMENT_IS_PRODUCTION, ENVIRONMENT_LABEL } from '../../../../constants/SystemEnums';
import { ScriptLoaderWithVisualBug, VendorLoaderProps } from './ScriptLoaderWithVisualBug';
import _                                                from 'underscore';

export const CORVAL_USERSNAP_API = `CORVAL_USERSNAP_API`;

export enum USERSNAP_ENV_IDS {
	TEST_BUG_REPORT      = '3ad65e8e-e149-4d5f-b9c4-1c5da7dee7cb',
	PROD_BUG_REPORT      = '825200cb-766f-476e-8356-2557e4e69de1',
	PROD_FEEDBACK_REPORT = '0acd3361-394c-462f-aa99-8668cf851cf2'
}

export enum USERSNAP_API_NAMES {
	TEST_BUG_REPORT      = 'Corval-Internal-Bug-Reporting',
	PROD_BUG_REPORT      = 'Corval-Production-Bug-Reporting',
	PROD_FEEDBACK_REPORT = 'Corval-Production-Feedback'
}

interface UserSnapVendorProps extends VendorLoaderProps {
	apiEnabled?: boolean,
	apiName?: string,
	init?: {
		defaultValues?: object,
		button?: object,
	};
}

const defaultProps: UserSnapVendorProps = {
	id:         null,
	apiEnabled: true,
	apiName:    null,
	init:       {}
}

const UserSnapForm: FC<UserSnapVendorProps> = ( { id, ...props } ) => {
	
	const initScript = () => {
		
		let script = document.createElement( 'script' );
		
		script.async = true;
		script.id    = `userSnapForm-${ ENVIRONMENT_LABEL }-${ id }`;
		script.src   = `https://widget.usersnap.com/load/${ id }?onload=onUsersnapCXLoad-${ id }`;
		
		if( !document.getElementById( script.id ) ){
			
			//@ts-ignore
			window[ `onUsersnapCXLoad-${ id }` ] = function( api ){
				
				api.init( props.init ?? {} );
				
				if( props.apiEnabled ){
					
					// Introduce corval's usersnap API object
					// eg: window["CORVAL_USERSNAP_API-Corval-Production-Bug-Reporting"]
					window[ `${ CORVAL_USERSNAP_API }-${ props.apiName ?? id }` ] = api
				}
			}
			
			document.getElementsByTagName( 'head' )[ 0 ].appendChild( script );
		}
		
	};
	
	return ( id ? <ScriptLoaderWithVisualBug onLoad={ initScript } { ...props }/> : null );
}

{/* Internal Bug Report */ }
const InternalBugReportForm: FC<UserSnapVendorProps> = ( props ) => (
	<UserSnapForm id={ USERSNAP_ENV_IDS.TEST_BUG_REPORT }
	              apiName={ USERSNAP_API_NAMES.TEST_BUG_REPORT }
	              { ...props }
	/>
);

{/* Production User Feedback */ }
const ProductionFeedbackForm: FC<UserSnapVendorProps> = ( props ) => (
	<UserSnapForm id={ USERSNAP_ENV_IDS.PROD_FEEDBACK_REPORT }
	              apiName={ USERSNAP_API_NAMES.PROD_FEEDBACK_REPORT }
	              init={ {
		              button: { isHidden: true }
	              } }
	              { ...props }
	/>
);

{/* Production Bug / Improvement Feedback */ }
const ProductionBugReportForm: FC<UserSnapVendorProps> = ( props ) => (
	<UserSnapForm id={ USERSNAP_ENV_IDS.PROD_BUG_REPORT }
	              apiName={ USERSNAP_API_NAMES.PROD_BUG_REPORT }
	              init={ {
		              button: { isHidden: true }
	              } }
	              { ...props }/>
);

const toggleUserSnapTabs = _.debounce( ( hideTabs ) => {
	
	if( !ENVIRONMENT_IS_PRODUCTION ){
		
		let userSnapAPIs = _.keys( window ).filter( key => key.includes( CORVAL_USERSNAP_API ) );
		
		let toggleMethod = hideTabs ? 'hideButton' : 'showButton';
		
		userSnapAPIs.map( APIKey => {
			
			let hasButton = Array.from( document.getElementsByName( 'us-entrypoint-buttonV2' ) ).length;
			
			if( window[ APIKey ] && (
				( ( toggleMethod === 'hideButton' ) && hasButton ) ||
				( ( toggleMethod === 'showButton' ) && !hasButton )
			) ){
				window[ APIKey ][ toggleMethod ]()
			}
		} );
	}
	
}, 200 );

UserSnapForm.defaultProps = defaultProps;

export {
	UserSnapForm,
	InternalBugReportForm,
	ProductionFeedbackForm,
	ProductionBugReportForm,
	toggleUserSnapTabs
}
